import { AiResponseAction } from '../types/ai-response.action.type';

export class AiChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  translate?: boolean;
  timestamp?: Date;
  actions?: AiResponseAction[];
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/ai-chat/models/ai-message.model.ts